var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { styledComponents } from '@datashop/theme';
var styled = styledComponents.default;
var Wrapper = styled.i(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: inherit;\n  font-family: 'Material Icons';\n  font-style: inherit;\n  font-feature-settings: 'liga';\n"], ["\n  font-size: inherit;\n  font-family: 'Material Icons';\n  font-style: inherit;\n  font-feature-settings: 'liga';\n"])));
var Icon = function (_a) {
    var name = _a.name, className = _a.className, rest = __rest(_a, ["name", "className"]);
    return (React.createElement(Wrapper, __assign({ className: "material-icons" + (className ? " " + className : '') }, rest), name));
};
export default Icon;
var templateObject_1;
//# sourceMappingURL=Icon.js.map